import React, { useEffect, useState } from "react";
import Block from "@insightfulscience/atomic-react/Block";

const AlertPreviewMode = () => {
	const [referer, setReferer] = useState("");
	useEffect(() => {
		setReferer(global.window.location.href);
	}, []);
	return (
		<Block
			utility={{ bgColor: "black" }}
			spacing={{ p: 4 }}
			style={{ position: "fixed", top: 0, right: 0, zIndex: 9999 }}
		>
			<a
				className="link text-color-white text-color-black--15--hover"
				href={`/api/preview-disable?referer=${encodeURIComponent(referer)}`}
			>
				Disable Preview Mode
			</a>
		</Block>
	);
};

export default AlertPreviewMode;
